module.exports = __webpack_public_path__ + "static/media/R2-dragging-nodes.3076d917.gif";